<template>
    <div class="devices">
        <el-row class="device-title">
            <el-col :span="8">
                <span class="h3">{{$t('ping_xian_guan_li')}}</span>
                <span class="manual">{{$t('ji_xing_fen_bian_lv_shou_ce')}}</span>
            </el-col>
        </el-row>
        <div class="device-data-list">
            <el-tabs v-model="activeName" >
                <el-tab-pane :label="$t('qi_dong')" name="logo">
                    <logo v-if="activeName === 'logo'"></logo>
                </el-tab-pane>
                <el-tab-pane :label="$t('dai_ji_ping_bao')" name="screenSaver">
                    <screen-saver v-if="activeName === 'screenSaver'"></screen-saver>
                </el-tab-pane>
                <el-tab-pane :label="$t('zhi_zuo_guo_cheng_zhan_shi_tu')" name="makePicture">
                    <make-picture v-if="activeName === 'makePicture'"></make-picture>
                </el-tab-pane>
                <el-tab-pane :label="$t('zhi_zuo_guo_cheng_shi_pin')" name="makeVideo">
                    <make-video v-if="activeName === 'makeVideo'"></make-video>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>

</template>

<script>
    import Logo from './logo'
    import MakePicture from './MakePicture'
    import MakeVideo from './MakeVideo'
    import ScreenSaver from './ScreenSaver'
    export default {
        name: '',
        components: {
            Logo,
            ScreenSaver,
            MakePicture,
            MakeVideo
        },
        mounted: function () {
        },
        data: function () {
            return {
                activeName: 'logo'
            }
        },
        filters: {},
        methods: {},
    }
</script>

<style lang="scss">
    .devices {
        padding: $padding $t-padding;
        display: flex;
        flex-direction: column;
        .device-title {
            .device-input-filter {
                input {
                    border: none;
                    border-bottom: 1px solid $f_fiv_color;
                    font-size: $filter-font-size;
                    border-radius: 0;
                }
            }
            .manual{
                font-size: .6rem;
                color: $btn_color;
                cursor: pointer;
            }
        }
        .device-data-list {
            margin-top: $padding;
            flex: 1;

            .device-info {
                .device-info-img {
                }
                .device-info-detail {

                    p {
                        margin-bottom: $padding-5;
                    }
                    p:first-child {
                        font-size: .8rem;
                    }
                }
            }

            .el-table {
                thead {
                    tr {
                        th {
                            border-bottom: 1px solid $border_sec_color;
                        }
                    }
                }

            }
            .el-table--group::after, .el-table--border::after, .el-table::before {
                background-color: transparent;
            }
            .el-table__row:hover {
                background-color: $bg_sec_color;
            }

            .device-edit, .device-delete {
                cursor: pointer;
                display: inline-block;
                margin-right: $padding;
            }
            .device-edit:hover, .device-delete:hover {
                color: $f_color;
            }
            .device-edit {
                color: $btn_color;
            }
            .device-delete {
                color: $btn_sec_color;
            }

            .circle {
                border-radius: $small_font_size;
                width: $small_font_size;
                height: $small_font_size;
                display: inline-block;
                margin-right: 5px;
            }

            .offline {
                color: #5B8FF9;
                .circle {
                    background-color: #5B8FF9;
                }
            }
            .normal {
                color: #5AD8A6;
                .circle {
                    background-color: #5AD8A6;
                }
            }

            .warning {
                color: #F6BD16;
                .circle {
                    background-color: #F6BD16;
                }
            }

            .fault {
                color: #E8684A;
                .circle {
                    background-color: #E8684A;
                }
            }

        }

        .pagination {
            margin: $padding;
            text-align: right;
        }
    }

</style>
